/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @nx/enforce-module-boundaries */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { GoogleMap, Marker, OverlayView, Polyline } from '@react-google-maps/api';
import { useGoogleMaps } from 'packages/novous_web/src/context/GoogleMapContext';
import { IconButton, useMediaQuery, useTheme } from '@mui/material';
import MapViewModal from 'packages/novous_web/src/common/components/MapViewModal';
import mapOption from 'packages/novous_web/src/assets/icons/Map Options.svg';
import plusIcon from 'packages/novous_web/src/assets/icons/plusBlue.svg';
import minusIcon from 'packages/novous_web/src/assets/icons/Minus Stroke.svg';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ClearIcon from '@mui/icons-material/Clear';
import PauseIcon from '@mui/icons-material/Pause';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import { useLocation } from 'react-router-dom';
import Drowsiness from '../../../../../assets/icons/Drowsiness.svg';
import Distracted from '../../../../../assets/icons/Distracted.svg';
import Phone_Calling from '../../../../../assets/icons/phone-calling.svg';
import Harsh_Braking from '../../../../../assets/icons/Hard Braking.svg';
import Forward_Collision from '../../../../../assets/icons/Forward Collision.svg';
import Camera_Block from '../../../../../assets/icons/Camera Block.svg';
import Lane_Departure from '../../../../../assets/icons/Location.svg';
import Vulnerable_Road_Alert from '../../../../../assets/icons/vulnerableRoadAlert.svg';
import Harsh_Acceleration from '../../../../../assets/icons/Harsh Acceleration.svg';
import Harsh_Turning from '../../../../../assets/icons/Harsh Turning.svg';
import Over_Speeding from '../../../../../assets/icons/Over Speeding.svg';
import Vehicle_Idling from '../../../../../assets/icons/VideoPlaybutton.svg';
import Continuous_Driving from '../../../../../assets/icons/ContinuousDrivingReport.svg';
import Night_Driving from '../../../../../assets/icons/NightDrivingEvent.svg';
import Smoking from '../../../../../assets/icons/Smoking.svg';
import Yawning from '../../../../../assets/icons/Yawning.svg';
import Seat_Belt from '../../../../../assets/icons/seatbelt.svg';
import vehicleIcon from 'packages/novous_web/src/assets/icons/MovingTruck.svg';
import Loader from 'packages/novous_web/src/common/components/Loader';
import { CircularProgress } from '@mui/material';
import { formatTimeTo24HourFormat } from 'packages/novous_web/src/utils/helper';
import { set } from 'react-datepicker/dist/date_utils';
import axisInstance from 'packages/novous_web/src/api/apiClient';
import { warningIcons } from '../../../Alarm/Vehicle-Alerts/helper/warningIcons';
import { getWarningIcon } from '../../../Alarm/Vehicle-Alerts/helper/warningIcons';
const defaultCenter = {
  lat: 28.6139,
  lng: 77.209,
};

interface TripDetailMapProps {
  startDate: string;
  endDate: string;
  stopsData: {
    index: number;
    latitude: number;
    longitude: number;
    gpsTime: string;
  }[];
  selectedTrip?: {
    latitude: number;
    longitude: number;
    startDate: string;
    endDate: string;
    type: string;
    startLat: number;
    startLong: number;
    endLat: number;
    endLong: number;
  };
  selectedvehicleData?: any;
  clearTrip?: () => void;
}

type AlertPoint = {
  latitude: number;
  longitude: number;
  alertName: string;
};

const RunningHistoryMap: React.FC<TripDetailMapProps> = ({
  stopsData,
  startDate,
  endDate,
  selectedTrip,
  selectedvehicleData,
  clearTrip,
}) => {
  const { isLoaded } = useGoogleMaps();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width:650px)');
  const containerRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [mapType, setMapType] = useState<'roadmap' | 'satellite' | 'terrain' | 'hybrid'>('roadmap');
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedPoint, setSelectedPoint] = useState<any>(null);
  const fetchID = useRef(0);
  const handleClear = () => {
    setSelectedMapData([]);
    setSelectedPoint(null);
    setSelectedMapPointsData([]);
    setIsSelected(false);
    setCurrentFetchType('default');
    setAnimationObj({
      isPlaying: false,
      animationIndex: 0,
      vehiclePosition: { lat: 0, lng: 0 },
    });
    clearTrip?.();
    if (animationRef.current) {
      clearInterval(animationRef.current);
    }
  };
  const [alertPointsData, setAlertPointsData] = useState<AlertPoint[]>([]);
  const {
    data: mapPointsData,
    loading: loadingMapPoints,
    fetchData: fetchmapPoints,
  } = useAxios<any>(API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP, 'POST');
  const {
    data: alertMapPoints,
    loading: loadingalertMapPoints,
    fetchData: fetchalertMapPoints,
  } = useAxios<any>(API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP_ALERTS, 'POST');
  const [nonAlertMapData, setNonAlertMapData] = useState<any[]>([]);
  const [selectedMapPointsData, setSelectedMapPointsData] = useState<any[]>([]);
  const [defaultMapData, setDefaultMapData] = useState<any[]>([]);
  const [alertDataCache, setAlertDataCache] = useState<any[]>([]);
  const [selectedMapData, setSelectedMapData] = useState<any[]>([]);
  const [currentFetchType, setCurrentFetchType] = useState<'default' | 'selected' | null>('default');
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const lastVehicle = location.state || {};
  const [vehicleData, setVehicleData] = useState<any>(lastVehicle);
  const [distantAlertPoints, setDistantAlertPoints] = useState<AlertPoint[]>([]);
  const [processedPolylinePath, setProcessedPolylinePath] = useState<google.maps.LatLngLiteral[]>([]);
  const [isProcessingRoute, setIsProcessingRoute] = useState(false);
  const { user } = useAuth();
  const [animationObj, setAnimationObj] = useState({
    isPlaying: false,
    animationIndex: 0,
    vehiclePosition: { lat: 0, lng: 0 },
  });
  const [heading, setHeading] = useState<number>(0);
  const [currentSpeed, setCurrentSpeed] = useState<{ speed: number; timer: string } | null>(null);
  const animationRef = useRef<number | null>(null);
  const [playbackSpeed, setPlaybackSpeed] = useState(1); // 1 = normal, 2 = fast, 0.5 = slow
  const [showSpeedOptions, setShowSpeedOptions] = useState(false);

  const warningIconMap = Object.fromEntries(
    warningIcons.map((item: any) => [item.warningName, item.iconName]),
  );

  const alertIcons = [
    { alertName: 'Drowsiness', alertIcon: Drowsiness },
    { alertName: 'Distracted', alertIcon: Distracted },
    { alertName: 'Phone Calling', alertIcon: Phone_Calling },
    { alertName: 'Harsh Braking', alertIcon: Harsh_Braking },
    { alertName: 'Forward Collision', alertIcon: Forward_Collision },
    { alertName: 'Camera Block', alertIcon: Camera_Block },
    { alertName: 'Lane Departure', alertIcon: Lane_Departure },
    { alertName: 'Vulnerable Road User', alertIcon: Vulnerable_Road_Alert },
    { alertName: 'Harsh Acceleration', alertIcon: Harsh_Acceleration },
    { alertName: 'Harsh Turning', alertIcon: Harsh_Turning },
    { alertName: 'Over Speeding', alertIcon: Over_Speeding },
    { alertName: 'Vehicle Idling', alertIcon: Vehicle_Idling },
    { alertName: 'Continuous Driving', alertIcon: Continuous_Driving },
    { alertName: 'Night Driving', alertIcon: Night_Driving },
    { alertName: 'Smoking', alertIcon: Smoking },
    { alertName: 'Yawning', alertIcon: Yawning },
    { alertName: 'Seat Belt', alertIcon: Seat_Belt },
  ];

  useEffect(() => {
    if (!selectedvehicleData && !lastVehicle) return;
    setVehicleData(selectedvehicleData || lastVehicle);
  }, [selectedvehicleData, lastVehicle]);

  useEffect(() => {
    console.log('Vehicle Data:', selectedvehicleData);
  }, [selectedvehicleData]);

  useEffect(() => {
    if (selectedvehicleData || defaultMapData.length > 0) {
      const defaultLat = defaultMapData[0]?.latitude;
      const defaultLng = defaultMapData[0]?.longitude;

      setMapCenter({
        lat: defaultLat ?? selectedvehicleData?.lastLatitude,
        lng: defaultLng ?? selectedvehicleData?.lastLongitude,
      });
    }
  }, [selectedvehicleData, defaultMapData]);

  useEffect(() => {
    console.log('Default Map Data:', defaultMapData);
  }, [defaultMapData]);

  const fetchMapData = (startDate: any, endDate: any, lastEvaluatedKey = null) => {
    setLoading(true);
    fetchmapPoints({
      fleetId: user?.customer_id,
      vehicleId: selectedvehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
      startDate: startDate,
      endDate: endDate,
      lastEvaluatedKey: lastEvaluatedKey,
    });
  };

  const fetchAlertMapData = (startDate: any, endDate: any, alertEvaluatedKey = null) => {
    fetchalertMapPoints({
      fleetId: user?.customer_id,
      vehicleId: selectedvehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
      startDate: startDate,
      endDate: endDate,
      alertEvaluatedKey: alertEvaluatedKey,
    });
  };

  const fetchAllMapPoints = async (
    startDate: any,
    endDate: any,
    vehicleId: any,
    sessionID: any,
    fetchType: any,
  ) => {
    if (fetchType === 'default') {
      setLoading(true);
    } else if (fetchType === 'selected') {
      setIsSelected(true);
    }
    let allPoints: any[] = [];
    let lastEvaluatedKey = null;

    do {
      const response: any = await axisInstance({
        url: API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP,
        method: 'POST',
        data: {
          fleetId: user?.customer_id,
          vehicleId: vehicleId,
          startDate: startDate,
          endDate: endDate,
          lastEvaluatedKey: lastEvaluatedKey,
        },
        responseType: 'json',
      });

      console.log('Fetched Map Points:', response);

      const data = response?.data?.data?.mapRenderList || [];
      allPoints = allPoints.concat(data);

      lastEvaluatedKey = response?.data?.data?.lastEvaluatedKey;
    } while (lastEvaluatedKey && sessionID === fetchID.current);

    if (sessionID === fetchID.current) {
      if (fetchType === 'default') {
        setDefaultMapData(allPoints.flat(1));
        console.log(defaultMapData, 'defaultMapData');
        setLoading(false);
      } else if (fetchType === 'selected') {
        setSelectedMapData(allPoints.flat(1));
      }
    }
  };

  const fetchAllMapAlertPoints = async (
    startDate: any,
    endDate: any,
    vehicleId: any,
    sessionID: any,
    fetchType: any,
  ) => {
    let allAlertPoints: any[] = [];
    let alertEvaluatedKey = null;

    do {
      const response: any = await axisInstance({
        url: API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP_ALERTS,
        method: 'POST',
        data: {
          fleetId: user?.customer_id,
          vehicleId: vehicleId,
          startDate: startDate,
          endDate: endDate,
          alertEvaluatedKey: alertEvaluatedKey,
        },
        responseType: 'json',
      });

      console.log('Fetched Map Points:', response);

      const data = response?.data?.data?.mapRenderList || [];
      allAlertPoints = allAlertPoints.concat(data);

      alertEvaluatedKey = response?.data?.data?.alertEvaluatedKey;
    } while (alertEvaluatedKey && sessionID === fetchID.current);

    if (sessionID === fetchID.current) {
      setAlertPointsData(allAlertPoints.flat(1));
      console.log(alertPointsData, 'alertPointsData');
    }
  };

  useEffect(() => {
    const fetchDefaultData = () => {
      fetchID.current += 1;
      setCurrentFetchType('default');
      setIsSelected(false);
      setSelectedMapData([]);
      setSelectedPoint(null);
      setDefaultMapData([]);
      setNonAlertMapData([]);
      setAlertPointsData([]);
      setSelectedMapPointsData([]);
      fetchAllMapPoints(
        startDate,
        endDate,
        selectedvehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
        fetchID.current,
        'default',
      );
      fetchAllMapAlertPoints(
        startDate,
        endDate,
        vehicleData?.vehicleRegistrationNo,
        fetchID.current,
        currentFetchType,
      );
    };
    setAnimationObj({
      isPlaying: false,
      animationIndex: 0,
      vehiclePosition: { lat: 0, lng: 0 },
    });
    if (animationRef.current) {
      clearInterval(animationRef.current);
    }
    fetchDefaultData();
  }, [startDate, endDate, vehicleData?.vehicleRegistrationNo]);

  useEffect(() => {
    console.log('Selected Trip:', selectedTrip);
    const resetAnimationState = () => {
      stopAnimation();
      setAnimationObj({
        isPlaying: false,
        animationIndex: 0,
        vehiclePosition: { lat: 0, lng: 0 },
      });
    };

    if (selectedTrip) {
      if (selectedTrip?.type === 'RUNNING') {
        const fetchSelectedData = () => {
          setCurrentFetchType('selected');
          setSelectedMapData([]);
          setSelectedPoint(null);
          resetAnimationState();
          fetchAllMapPoints(
            selectedTrip.startDate,
            selectedTrip.endDate,
            selectedvehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
            fetchID.current,
            'selected',
          );
        };
        fetchSelectedData();
      } else if (selectedTrip?.type === 'IDLE' || selectedTrip?.type === 'STOP') {
        setCurrentFetchType('selected');
        setIsSelected(true);
        setSelectedMapData([]);
        setSelectedPoint(null);
        resetAnimationState();
        setSelectedPoint({
          lat: selectedTrip.startLat || selectedTrip.endLat,
          lng: selectedTrip.startLong || selectedTrip.endLong,
        });
      }
    } else {
      setCurrentFetchType('default');
      setSelectedMapData([]);
      resetAnimationState();
    }
  }, [selectedTrip]);

  useEffect(() => {
    if (!selectedPoint && (!selectedMapData || selectedMapData.length === 0) && defaultMapData.length > 0) {
      setMapCenter({
        lat: defaultMapData[0]?.latitude || defaultCenter.lat,
        lng: defaultMapData[0]?.longitude || defaultCenter.lng,
      });
      return;
    }
    if (selectedTrip?.type === 'RUNNING') {
      setMapCenter({ lat: selectedMapData[0]?.latitude, lng: selectedMapData[0]?.longitude });
    } else if (selectedTrip?.type === 'IDLE' || selectedTrip?.type === 'STOP') {
      setMapCenter({
        lat: selectedPoint?.lat || defaultCenter.lat,
        lng: selectedPoint?.lng || defaultCenter.lng,
      });
    }
  }, [selectedMapData, selectedPoint]);

  const defaultPolylinePath = useMemo(
    () =>
      defaultMapData
        .filter(
          (p) => typeof p.latitude === 'number' && typeof p.longitude === 'number' && p.type === 'NO_ALERT',
        )
        .map((p) => ({ lat: p.latitude, lng: p.longitude })),
    [defaultMapData],
  );

  const AlertPointsData = useMemo(
    () => alertPointsData.map((p) => ({ lat: p.latitude, lng: p.longitude, type: p.alertName })),
    [alertPointsData],
  );

  useEffect(() => {
    if (AlertPointsData.length > 1) {
      const distantPoints: AlertPoint[] = [];

      for (let i = 0; i < AlertPointsData.length - 1; i++) {
        const point1 = AlertPointsData[i];
        const point2 = AlertPointsData[i + 1];

        const distance = calculateDistance(point1, point2);

        console.log(`Distance between alert point ${i} and ${i + 1}: ${distance.toFixed(2)} km`);

        if (distance > 2) {
          if (!distantPoints.some(p => p.latitude === point1.lat && p.longitude === point1.lng)) {
            distantPoints.push({
              latitude: point1.lat,
              longitude: point1.lng,
              alertName: point1.type || 'Unknown Alert'
            });
          }

          if (!distantPoints.some(p => p.latitude === point2.lat && p.longitude === point2.lng)) {
            distantPoints.push({
              latitude: point2.lat,
              longitude: point2.lng,
              alertName: point2.type || 'Unknown Alert'
            });
          }

          console.log(`Points are more than 2km apart:`, point1, point2);
        }
      }

      setDistantAlertPoints(distantPoints);
      console.log('Distant alert points (>2km):', distantPoints);
    }
  }, [AlertPointsData]);

  const calculateDistance = (point1: { lat: number; lng: number }, point2: { lat: number; lng: number }): number => {
    if (!point1 || !point2) return 0;

    // Use Google Maps geometry if available
    if (window.google?.maps?.geometry?.spherical) {
      return google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(point1.lat, point1.lng),
        new google.maps.LatLng(point2.lat, point2.lng)
      ) / 1000; // Convert to kilometers
    }

    // Fallback Haversine formula
    const R = 6371; // Earth's radius in km
    const dLat = deg2rad(point2.lat - point1.lat);
    const dLon = deg2rad(point2.lng - point1.lng);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(point1.lat)) * Math.cos(deg2rad(point2.lat)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const deg2rad = (deg: number): number => deg * (Math.PI / 180);

  // Update the useEffect that processes the polyline
  useEffect(() => {
    if (defaultPolylinePath.length > 1) {
      processPolylineWithRoutes(defaultPolylinePath);
    } else if (defaultPolylinePath.length === 1) {
      // Handle single point case
      setProcessedPolylinePath(defaultPolylinePath);
    }
  }, [defaultPolylinePath]);

  // Add retry mechanism for route processing
  const [retryCount, setRetryCount] = useState(0);

  const retryRouteProcessing = useCallback(() => {
    if (retryCount < 3 && defaultPolylinePath.length > 1) {
      setRetryCount(prev => prev + 1);
      processPolylineWithRoutes(defaultPolylinePath);
    }
  }, [defaultPolylinePath, retryCount]);

  const processPolylineWithRoutes = async (path: google.maps.LatLngLiteral[]) => {
    if (!path.length) {
      setProcessedPolylinePath(path);
      return;
    }

    setIsProcessingRoute(true);

    try {
      const processedPath: google.maps.LatLngLiteral[] = [path[0]]; // Start with first point

      for (let i = 0; i < path.length - 1; i++) {
        const point1 = path[i];
        const point2 = path[i + 1];

        // Skip invalid points
        if (!point1 || !point2 || !point1.lat || !point1.lng || !point2.lat || !point2.lng) {
          continue;
        }

        const distance = calculateDistance(point1, point2);
        const hasDataLoss = checkForDataLoss(point1, point2, distance);

        // If distance is more than 2km OR if we can't get proper route data, use Directions API
        if (hasDataLoss && window.google?.maps?.DirectionsService) {
          console.log(`Data loss detected between points ${i} and ${i + 1}, getting road route`);

          try {
            const route = await getRouteBetweenPoints(point1, point2);
            if (route && route.length > 0) {
              processedPath.push(...route.slice(1));
            } else {
              // Fallback for when Directions API fails
              const intermediatePoints = getIntermediatePoints(point1, point2, Math.ceil(distance));
              processedPath.push(...intermediatePoints);
            }
          } catch (error) {
            console.error('Error getting route:', error);
            const intermediatePoints = getIntermediatePoints(point1, point2, Math.ceil(distance));
            processedPath.push(...intermediatePoints);
          }
        } else {
          // No data loss, use the original point
          processedPath.push(point2);
        }
      }

      setProcessedPolylinePath(processedPath);
    } catch (error) {
      console.error('Error processing polyline:', error);
      setProcessedPolylinePath(path);
    } finally {
      setIsProcessingRoute(false);
    }
  };

  const checkForDataLoss = (point1: google.maps.LatLngLiteral, point2: google.maps.LatLngLiteral, distance: number): boolean => {
    // Condition 1: Large distance gap (more than 2km)
    if (distance > 2) return true;

    // Condition 2: Sudden jump in coordinates (unrealistic movement)
    const latDiff = Math.abs(point2.lat - point1.lat);
    const lngDiff = Math.abs(point2.lng - point1.lng);

    // If coordinates jump too much in a short time (adjust thresholds as needed)
    if (latDiff > 0.1 || lngDiff > 0.1) return true;

    // Condition 3: You can add more data loss detection logic here
    // For example, check timestamp gaps if you have time data

    return false;
  };

  const getRouteBetweenPoints = async (
    origin: google.maps.LatLngLiteral,
    destination: google.maps.LatLngLiteral
  ): Promise<google.maps.LatLngLiteral[]> => {
    return new Promise((resolve, reject) => {
      if (!window.google?.maps?.DirectionsService) {
        reject(new Error('Google Maps Directions API not available'));
        return;
      }

      const directionsService = new google.maps.DirectionsService();

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: google.maps.TravelMode.DRIVING,
          provideRouteAlternatives: false, // Set to true if you want multiple routes
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK && result?.routes?.[0]) {
            const route = result.routes[0];
            const path: google.maps.LatLngLiteral[] = [];

            // Extract all points from the route
            route.legs.forEach(leg => {
              leg.steps.forEach(step => {
                step.path.forEach(latLng => {
                  path.push({
                    lat: latLng.lat(),
                    lng: latLng.lng()
                  });
                });
              });
            });

            console.log(`Route found with ${path.length} points`);
            resolve(path);
          } else {
            console.warn(`Directions request failed: ${status}, using fallback`);
            reject(new Error(`Directions request failed: ${status}`));
          }
        }
      );
    });
  };

  const getIntermediatePoints = (
    start: google.maps.LatLngLiteral,
    end: google.maps.LatLngLiteral,
    numPoints: number
  ): google.maps.LatLngLiteral[] => {
    const points: google.maps.LatLngLiteral[] = [];

    for (let i = 1; i <= numPoints; i++) {
      const ratio = i / (numPoints + 1);
      points.push({
        lat: start.lat + (end.lat - start.lat) * ratio,
        lng: start.lng + (end.lng - start.lng) * ratio,
      });
    }

    points.push(end); // Add the final point
    return points;
  };

  const selectedPolylinePath = (selectedMapData ?? [])
    .filter((p) => typeof p.latitude === 'number' && typeof p.longitude === 'number')
    .map((p) => ({ lat: p.latitude, lng: p.longitude }));

  if (!isLoaded) return <div>Loading Map...</div>;

  const toggleFullscreen = () => {
    if (!containerRef.current) return;
    if (!document.fullscreenElement) {
      containerRef.current.requestFullscreen().then(() => setIsFullscreen(true));
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false));
    }
  };

  const speedOptions = [
    { label: '0.5x', value: 0.5 },
    { label: '1x', value: 1 },
    { label: '1.5x', value: 1.5 },
    { label: '2x', value: 2 },
  ];

  const startAnimation = () => {
    console.log(defaultPolylinePath, 'selectedPolylinePath starting.....', selectedPolylinePath);

    if (currentFetchType == 'selected') {
      if (!selectedPolylinePath || selectedPolylinePath.length === 0) {
        console.error('No path available for animation.');
        return;
      }
      setAnimationObj((prev) => {
        return {
          isPlaying: true,
          animationIndex: prev.animationIndex,
          vehiclePosition: selectedPolylinePath[prev.animationIndex],
        };
      });

      let currentSegmentIndex = animationObj.animationIndex;
      let progress = 0;

      const interpolate = (
        start: { lat: number; lng: number },
        end: { lat: number; lng: number },
        t: number,
      ) => {
        return {
          lat: start.lat + (end.lat - start.lat) * t,
          lng: start.lng + (end.lng - start.lng) * t,
        };
      };

      const baseInterval = 50;
      const interval = baseInterval / playbackSpeed;

      animationRef.current = window.setInterval(() => {
        if (currentSegmentIndex >= selectedPolylinePath.length - 1) {
          stopAnimation(true);
          return;
        }

        progress += 0.025 * playbackSpeed;

        if (progress >= 1) {
          progress = 0;
          currentSegmentIndex++;
        }

        if (currentSegmentIndex < selectedPolylinePath.length - 1) {
          const startPoint = selectedPolylinePath[currentSegmentIndex];
          const endPoint = selectedPolylinePath[currentSegmentIndex + 1];
          const interpolatedPosition = interpolate(startPoint, endPoint, progress);
          const newHeading = getHeading(startPoint, interpolatedPosition);
          if (newHeading !== 0) {
            setHeading(getHeading(startPoint, interpolatedPosition));
          }
          setAnimationObj((prev) => {
            return {
              isPlaying: prev.isPlaying,
              animationIndex: currentSegmentIndex,
              vehiclePosition: interpolatedPosition,
            };
          });

          const speedInfo = selectedMapData[currentSegmentIndex];
          const timeInfo = speedInfo.timeStamp || '';
          const modifiedTimeInfo = timeInfo.replace(/ /g, '');
          setCurrentSpeed({ speed: speedInfo.speed, timer: modifiedTimeInfo });
        }
      }, 50);
    } else {
      if (!defaultPolylinePath || defaultPolylinePath.length === 0) {
        console.error('No path available for animation.');
        return;
      }

      setAnimationObj((prev) => {
        return {
          isPlaying: true,
          animationIndex: prev.animationIndex,
          vehiclePosition: defaultPolylinePath[prev.animationIndex],
        };
      });

      let currentSegmentIndex = animationObj.animationIndex;
      let progress = 0;

      const interpolate = (
        start: { lat: number; lng: number },
        end: { lat: number; lng: number },
        t: number,
      ) => {
        return {
          lat: start.lat + (end.lat - start.lat) * t,
          lng: start.lng + (end.lng - start.lng) * t,
        };
      };

      animationRef.current = window.setInterval(() => {
        if (currentSegmentIndex >= defaultPolylinePath.length - 1) {
          stopAnimation(true);
          return;
        }

        progress += 0.025 * playbackSpeed;

        if (progress >= 1) {
          progress = 0;
          currentSegmentIndex++;
        }

        if (currentSegmentIndex < defaultPolylinePath.length - 1) {
          const startPoint = defaultPolylinePath[currentSegmentIndex];
          const endPoint = defaultPolylinePath[currentSegmentIndex + 1];
          const interpolatedPosition = interpolate(startPoint, endPoint, progress);
          const newHeading = getHeading(startPoint, interpolatedPosition);
          if (newHeading !== 0) {
            setHeading(getHeading(startPoint, interpolatedPosition));
          }
          setAnimationObj((prev) => {
            return {
              isPlaying: prev.isPlaying,
              animationIndex: currentSegmentIndex,
              vehiclePosition: interpolatedPosition,
            };
          });

          const speedInfo = defaultMapData[currentSegmentIndex];
          const timeInfo = speedInfo.timeStamp || '';
          const modifiedTimeInfo = timeInfo.replace(/ /g, '');
          setCurrentSpeed({ speed: speedInfo.speed, timer: modifiedTimeInfo });
        }
      }, 50);
    }
  };

  const handleSpeedChange = (speed: number) => {
    setPlaybackSpeed(speed);
    setShowSpeedOptions(false);

    // If animation is currently playing, restart it with new speed
    if (animationObj.isPlaying) {
      stopAnimation();
      setTimeout(() => {
        startAnimation();
      }, 100);
    }
  };

  const getHeading = (from: google.maps.LatLngLiteral, to: google.maps.LatLngLiteral): number => {
    return google.maps.geometry.spherical.computeHeading(
      new google.maps.LatLng(from.lat, from.lng),
      new google.maps.LatLng(to.lat, to.lng),
    );
  };

  const stopAnimation = (isCompleted = false) => {
    console.log(animationRef.current, 'animationRef.current ');

    if (animationRef.current && !isCompleted) {
      clearInterval(animationRef.current);
      setAnimationObj((prev) => {
        return {
          isPlaying: false,
          animationIndex: prev.animationIndex,
          vehiclePosition: selectedPolylinePath[prev.animationIndex],
        };
      });

      animationRef.current = null;
    } else if (animationRef.current && isCompleted) {
      clearInterval(animationRef.current);
      setAnimationObj((prev) => {
        return {
          isPlaying: false,
          animationIndex: 0,
          vehiclePosition: selectedPolylinePath[0],
        };
      });

      animationRef.current = null;
    }
  };

  useEffect(() => {
    return () => {
      if (animationRef.current) {
        clearInterval(animationRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (animationObj.isPlaying && animationObj.vehiclePosition) {
      setMapCenter(animationObj.vehiclePosition);
    }
  }, [animationObj]);

  console.log(animationObj, 'animatedObj');

  return (
    <>
      <MapViewModal open={open} mapType={mapType} onClose={() => setOpen(false)} onSelect={setMapType} />
      <div
        ref={containerRef}
        style={{ position: 'relative', width: '100%', height: isSmallScreen ? '400px' : '100%' }}
      >
        {loading && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'transparent',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        )}
        {isSelected && (
          <div style={{ position: 'absolute', top: 10, right: 190, zIndex: 1000 }}>
            <IconButton
              onClick={handleClear}
              sx={{ bgcolor: 'white', padding: '8px', boxShadow: 2 }}
            >
              <ClearIcon sx={{ fontSize: 32 }} />
            </IconButton>
          </div>
        )}
        <div style={{ position: 'absolute', top: 10, right: 130, zIndex: 1000 }}>
          <IconButton
            onClick={() => {
              animationObj.isPlaying ? stopAnimation() : startAnimation();
            }}
            sx={{ bgcolor: 'white', padding: '8px', boxShadow: 2 }}
          >
            {animationObj.isPlaying ? (
              <PauseIcon sx={{ fontSize: 32 }} />
            ) : (
              <PlayArrowIcon sx={{ fontSize: 32 }} />
            )}
          </IconButton>
        </div>
        <div style={{ position: 'absolute', top: 10, right: 190, zIndex: 1000, display: animationObj.isPlaying ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
          <IconButton
            onClick={() => {
              const newSpeed = Math.max(0.25, playbackSpeed - 0.25);
              handleSpeedChange(newSpeed);
            }}
            sx={{ bgcolor: 'white', padding: '8px', boxShadow: 2 }}
            disabled={playbackSpeed <= 0.25}
          >
            <img src={minusIcon} width={32} height={32} />
          </IconButton>
          <IconButton
            sx={{ bgcolor: 'white', padding: '8px', boxShadow: 2 }}
          >
            <span style={{ fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px' }}>
              {playbackSpeed}x
            </span>
          </IconButton>
          <IconButton
            onClick={() => {
              const newSpeed = Math.min(4, playbackSpeed + 0.25);
              handleSpeedChange(newSpeed);
            }}
            sx={{ bgcolor: 'white', padding: '8px', boxShadow: 2 }}
            disabled={playbackSpeed >= 4}
          >
            <img src={plusIcon} width={32} height={32} />
          </IconButton>
        </div>
        <div style={{ position: 'absolute', top: 10, right: 70, zIndex: 1000 }}>
          <IconButton onClick={() => setOpen(true)} sx={{ bgcolor: 'white', padding: '8px', boxShadow: 2 }}>
            <img src={mapOption} width={32} height={32} />
          </IconButton>
        </div>
        <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
          <IconButton onClick={toggleFullscreen} sx={{ bgcolor: 'white', padding: '8px', boxShadow: 2 }}>
            {isFullscreen === true ? (
              <FullscreenExitIcon sx={{ fontSize: 32 }} />
            ) : (
              <FullscreenIcon sx={{ fontSize: 32 }} />
            )}
          </IconButton>
        </div>

        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={mapCenter}
          zoom={animationObj.isPlaying ? 14 : 12}
          options={{
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeId: mapType,
            keyboardShortcuts: false,
          }}
        >
          {isProcessingRoute && processedPolylinePath.length === 0 && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1000,
              background: 'white',
              padding: '15px',
              borderRadius: '8px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
              textAlign: 'center'
            }}>
              <CircularProgress size={20} style={{ marginRight: '10px' }} />
              Calculating road routes...
            </div>
          )}

          {(processedPolylinePath.length > 1 ? processedPolylinePath : defaultPolylinePath).length > 1 && (
            <Polyline
              path={processedPolylinePath.length > 1 ? processedPolylinePath : defaultPolylinePath}
              options={{
                strokeColor: processedPolylinePath.length > 1 ? 'blue' : 'blue',
                strokeOpacity: 0.7,
                strokeWeight: processedPolylinePath.length > 1 ? 4 : 3,
                geodesic: true,
                zIndex: 1,
              }}
            />
          )}

          {selectedPolylinePath.length > 1 && (
            <Polyline
              path={selectedPolylinePath}
              options={{
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 4,
                geodesic: true,
                zIndex: 2,
              }}
            />
          )}

          {defaultPolylinePath.length > 0 && (
            <>
              <Marker
                key="Source"
                position={{
                  lat: defaultPolylinePath[0].lat,
                  lng: defaultPolylinePath[0].lng,
                }}
                icon={{
                  url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                }}
                label={{
                  text: 'S',
                  color: 'white',
                  fontWeight: 'bold',
                }}
              />

              <Marker
                key="Destination"
                position={{
                  lat: defaultPolylinePath[defaultPolylinePath.length - 1].lat,
                  lng: defaultPolylinePath[defaultPolylinePath.length - 1].lng,
                }}
                icon={{
                  url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                }}
                label={{
                  text: 'D',
                  color: 'white',
                  fontWeight: 'bold',
                }}
              />
            </>
          )}

          {AlertPointsData.map((alert, index) => {
            const matchedIcon = getWarningIcon(alert.type) || null;
            console.log('Matched Icon:', matchedIcon, 'Alert Type:', alert.type);
            return (
              <Marker
                key={`alert-${index}`}
                position={{ lat: alert.lat, lng: alert.lng }}
                icon={{
                  url: matchedIcon ? matchedIcon : 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
                  scaledSize: new window.google.maps.Size(32, 32),
                }}
                label={''}
              />
            );
          })}

          {selectedTrip && selectedPolylinePath.length > 0 && (
            <>
              <Marker
                position={{
                  lat: selectedPolylinePath[0]?.lat ?? defaultCenter.lat,
                  lng: selectedPolylinePath[0]?.lng ?? defaultCenter.lng,
                }}
                label="Start"
                icon={{
                  url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
                }}
              />
              <Marker
                position={{
                  lat: selectedPolylinePath[selectedPolylinePath.length - 1]?.lat ?? defaultCenter.lat,
                  lng: selectedPolylinePath[selectedPolylinePath.length - 1]?.lng ?? defaultCenter.lng,
                }}
                label="End"
                icon={{
                  url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                }}
              />
            </>
          )}

          {selectedTrip && selectedPoint && (
            <>
              <Marker
                position={{
                  lat: selectedPoint?.lat ?? defaultCenter.lat,
                  lng: selectedPoint?.lng ?? defaultCenter.lng,
                }}
                label={selectedTrip?.type === 'IDLE' ? 'IDLE' : 'STOP'}
                icon={
                  selectedTrip?.type === 'IDLE'
                    ? {
                      url: 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
                    }
                    : {
                      url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                    }
                }
              />
            </>
          )}

          {animationObj.vehiclePosition && (
            <OverlayView
              position={animationObj.vehiclePosition}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div
                style={{
                  transform: `rotate(${heading}deg)`,
                  transition: 'transform 0.3s ease',
                  width: '50px',
                  height: '50px',
                  top: '-25px',
                  left: '-25px',
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img src={vehicleIcon} alt="truck" style={{ width: '100%', height: '100%' }} />
              </div>
            </OverlayView>
          )}

          {/* Custom Info Box */}
          {animationObj.vehiclePosition && (
            <OverlayView
              position={animationObj.vehiclePosition}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div
                style={{
                  background: 'white',
                  padding: '8px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                  marginBottom: '40px',
                  minWidth: '100px', // 👈 Set min width or fixed width
                  textAlign: 'center',
                }}
              >
                <div>
                  <strong>Speed:</strong> {currentSpeed?.speed ?? 0} km/h
                </div>
                <div>
                  <strong>Time:</strong> {formatTimeTo24HourFormat(currentSpeed?.timer ?? '')}
                </div>
              </div>
            </OverlayView>
          )}
        </GoogleMap>
      </div>
    </>
  );
};

export default RunningHistoryMap;
